import { useEffect, useState } from 'react';
// @mui
import { Box, Divider, Stack } from '@mui/material';
// redux
import { useDispatch } from '../../../redux/store';
// routes
//
import useAuth from '../../../hooks/useAuth';
import ChatHeaderDetail from './ChatHeaderDetail';
import ChatMessageInput from './ChatMessageInput';
import ChatMessageList from './ChatMessageList';
import ChatRoom from './ChatRoom';
import { UserUtils } from '../../../api_utils';

// ----------------------------------------------------------------------

const conversationSelector = (state) => {
  const { conversations, activeConversationId } = state.chat;
  const conversation = activeConversationId ? conversations.byId[activeConversationId] : null;
  if (conversation) {
    return conversation;
  }
  const initState = {
    id: '',
    messages: [],
    participants: [],
    unreadCount: 0,
    type: '',
  };
  return initState;
};

export default function ChatWindow({ socket, conversation }) {
  const [messages, setMessages] = useState(conversation?.messages);
  const [joiningRoom, setJoiningRoom] = useState(false);
  const { user } = useAuth();

  const handleSendMessage = async (message) => {
    setMessages(prev => [...prev, { time: new Date(), text: message, from_id: user.id }, { time: new Date(), text: "%LOADING%", from_id: -1 }])
    const res = await UserUtils.queryGraceAssistant(message);
    if (res.success) {
      setMessages(prev => [...prev.filter(x => x.text !== "%LOADING%"), { time: new Date(), text: res.data, from_id: -1 }])
    } else {
      setMessages(prev => [...prev.filter(x => x.text !== "%LOADING%"), { time: new Date(), text: res.message, from_id: -1 }])
    }
  };
  useEffect(() => {
    if (conversation) {
      setMessages(conversation.messages);
    }
  }, [conversation])

  return (
    <Stack sx={{ flexGrow: 1, minWidth: '1px' }}>
      <ChatHeaderDetail conversation={conversation} participants={[]} />

      <Divider />

      <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
        <Stack sx={{ flexGrow: 1 }}>
          <ChatMessageList conversation={conversation} messages={messages} joiningRoom={joiningRoom} />

          <Divider />

          <ChatMessageInput
            conversationId={user.grace_thread_id}
            onSend={handleSendMessage}
            disabled={false}
          />
        </Stack>

        {/* {mode === 'DETAIL' && <ChatRoom conversation={conversation} participants={displayParticipants} />} */}
      </Box>
    </Stack >
  );
}
